import { RpcService } from '@holmescorp/rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/@@ml.rpc`,
    services: {
        recommended_study_plan: {
            parameters: [
                { name: 'studyTrack', type: 'string', optional: false },
                { name: 'scores', type: 'object', optional: true },
                { name: 'tgf_recommendations', type: 'int', optional: true }
            ]
        }
    }
});
export default svc;
